import { NextResponse } from "next/server";
import type { NextRequest } from "next/server";
import { getSession } from "@/lib/auth";

export async function proxy(request: NextRequest) {
    const session = await getSession();

    if (
        request.nextUrl.pathname.startsWith("/admin") &&
        request.nextUrl.pathname !== "/admin"
    ) {
        if (!session) {
            return NextResponse.redirect(new URL("/admin", request.url));
        }
    }

    if (request.nextUrl.pathname === "/admin" && session) {
        return NextResponse.redirect(new URL("/admin/dashboard", request.url));
    }

    return NextResponse.next();
}

export const config = { matcher: ["/admin/:path*"] };
